import { Form } from 'antd';

import Input from '@/components/Inputs/Input';

export const TitleField = () => {
  return (
    <Form.Item label="Title" name="title">
      <Input placeholder="Type title" sizeType="m" />
    </Form.Item>
  );
};
